export default __webpack_public_path__ + "static/media/addressVerification.0290364e.svg";